import React , {useEffect, useState} from 'react';
import {Link as RouterLink, useLocation, useHistory} from 'react-router-dom';
import Link from '@mui/material/Link';
import {Button , Container, Grid,  Tooltip} from '@mui/material'
import {Print} from '@mui/icons-material';
import {DataGrid, GridToolbar} from '@mui/x-data-grid';
import {ShippingInstructionService} from '../../services';
import {Copy} from "react-feather";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import IconButton from "@mui/material/IconButton";
import ClearIcon from '@mui/icons-material/Clear';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import moment from 'moment/moment';

const ShippingInstructions = () => {
        const [list, setList] = useState([]);
        const [tempRow, setTempRow] = useState([]);
        const [page, setPage] = useState(0);
        const [searchTerm, setSearchTerm] = useState('');
        const [rowCount, setRowCount] = useState(0);
        const [loading, setLoading] = useState(false);
        const initialValue = {countries: '', partners: '', shipmentModes: '', clientIncoTerms: '', vendorIncoTerms: '', commodityTypes: ''};
       
        const [countries, setCountries] = useState([]);
        const [partners, setPartners] = useState([]);
        const [shipmentModes, setShipmentModes] = useState([]);
        const [clientIncoTerms, setClientIncoTerms] = useState([]);
        const [vendorIncoTerms, setVendorIncoTerms] = useState([]);
        const [commodityTypes, setCommodityTypes] = useState([]);
        const [accessToView, setAccessToView] = useState(true);
        const [poSearchError, setPOSearchError] = useState(false);
        const [rowList,  setRowList] = useState([]);
        const roleList = localStorage.getItem('Roles');
        const location = useLocation();
        const history = useHistory();
        const poNumber = location?.state;
        var savedFilters = JSON.parse(localStorage.getItem("Si"));      
        const [searchParam, setSearchParam] = useState(JSON.parse(localStorage.getItem("SiSearch"))? JSON.parse(localStorage.getItem("SiSearch")) : '');  
        const [selected, setSelected] = useState(JSON.parse(localStorage.getItem("Si")) ? JSON.parse(localStorage.getItem("Si")) : initialValue);
        const columns = [
            {
                field: 'grantCode', headerName: 'Grant Code', width: 130, flex: 1,
                renderCell: (params) => (
                    <Link style={{textDecoration: 'none'}} component={RouterLink} 
                    to={accessToView ? '/shipping-instruction/' + params.row.id : '/shipping-instruction-print/'  + params.row.id}>
                        {params.value}
                    </Link>
                )
            },
            {field: 'country', headerName: 'Country', width: 150, flex: 1.3},
            {field: 'consignee', headerName: 'Consignee Name', width: 150, flex: 1.5},
            {field: 'partner', headerName: 'Partner Sites (Ship-to)', width: 150, flex: 1},
            {field: 'shipmentMode', headerName: 'Shipment Mode', width: 80},
            {field: 'vendorIncoTerm', headerName: 'Vendor Inco Term', width: 80},
            {field: 'clientIncoTerm', headerName: 'Client Inco Term', width: 80},    
            {field: 'commodityTypes', headerName: 'commodity Types', width: 200, flex: 1.8,
             renderCell: (params) => (
                   params.formattedValue.map((value) => (
                    <span> {value}, </span>
                   ))
             )},
             {field: 'lastUpdated', headerName: 'Last Modified Date', width: 150,  valueFormatter: params => 
             params.value ? moment(params?.value).format("DD/MM/YYYY hh:mm A") : '',},

            {
                field: 'partnerSite', headerName: 'Action', width: 150,
                renderCell: (params) => (
                    <Grid spacing={2} container>
                        <Grid item={2}>
                            <Link component={RouterLink} to={'/shipping-instruction-print/' + params.row.id}>
                                <Tooltip title="Print Preview">
                                    <Print style={{marginTop: '20px'}}/>
                                </Tooltip>
                            </Link>
                        </Grid>
                        <Grid item={2}>
                            <Link component={RouterLink} to={'/shipping-instruction/start-' + params.row.id}>
                                <Tooltip title="Duplicate">
                                    <Copy style={{marginTop: '20px', width: 18, height: 18}} />
        
                                </Tooltip>
                            </Link>
                        </Grid>
                    </Grid>
                )
            }        
        ]
        const filterParams = [];

        React.useEffect(() => {   
            setLoading(true);
            if(savedFilters !== initialValue){      
              setSelected(JSON.parse(localStorage.getItem("Si")));
               }else{
                localStorage.setItem('Si', JSON.stringify(initialValue))
               }
            if(poNumber){
              setLoading(true);
              setSearchTerm(poNumber);           
             if(history.action !== "POP"){              
              poLookup(location?.event);
             }
            }            
            ShippingInstructionService.getById('options')
            .then((response) => {
                setCountries(response.data?.countries);
                setPartners(response.data?.partners);
                setShipmentModes(response.data?.shipmentModes);
                setClientIncoTerms(response.data?.clientIncoTerms);
                setVendorIncoTerms(response.data?.vendorIncoTerms);
                setCommodityTypes(response.data?.commodityTypes);
            })
            ShippingInstructionService.search({page: page})
                .then((response) => {
                    setRowCount(response.data.totalRecords);
                    setList(response.data.results);
                    setTempRow(response.data.results);   
                    if(savedFilters){
                      setLoading(true);  
                      setSelected(JSON.parse(localStorage.getItem("Si")));
                    }               
                     setLoading(false)
                });              
                 if(roleList){
                     let roleSet = roleList.split(',');
                     if(roleSet.includes('ROLE_SI_USER') && (roleSet.indexOf('ROLE_SI_ADMIN') === -1 && roleSet.indexOf('ROLE_SI_EDITOR') === -1)){
                        setAccessToView(false);
                     }
                     }
         // eslint-disable-next-line
        }, [page,  roleList]);

    

         const handleChange = (param, e) => {
            setSelected({
                ...selected, 
                [param]: e.target.value});
                          }          
 
        useEffect(() => {       
            filterList();   
            localStorage.setItem('Si', JSON.stringify(selected));
            localStorage.setItem('code', 'Si');      
             
        },[selected]);

        useEffect(() => {
          localStorage.setItem('SiSearch', JSON.stringify(searchParam));      
            searchKey(searchParam);      
        },[rowList, searchParam]);    
         

        const filterList = () => {   
            setLoading(true)
             selected.countries !== '' && filterParams.push({'country' : selected.countries})
             selected.partners !== '' && filterParams.push({'partner' : selected.partners})
             selected.shipmentModes !== '' && filterParams.push({'shipmentMode' : selected.shipmentModes})
             selected.clientIncoTerms !== '' && filterParams.push({'clientIncoTerm' : selected.clientIncoTerms})
             selected.vendorIncoTerms !== '' && filterParams.push({'vendorIncoTerm' : selected.vendorIncoTerms})
             selected.commodityTypes !== '' && filterParams.push({'commodityTypes' : selected.commodityTypes})
             let tempList = tempRow;
             filterParams.forEach(parent => {
                const filterBUffer = [] ;    
                tempList.forEach(el => {             
                 Object.entries(el).map(key => {
                    let parentKey = Object.keys(parent).toString();
                    let parentValue = Object.values(parent).toString();                    
                    if(key[0] === parentKey){
                      if(parentKey === 'commodityTypes'){
                        key[1].map(entry => {
                          if(parentValue.indexOf(entry) > -1){
                            filterBUffer.push(el);
                          }
                        })                        
                      }else if(key[1] === parentValue){
                            filterBUffer.push(el);
                        }
                    }
                 })               
                 })
                 tempList = filterBUffer;    
                 setLoading(false);                        
            });
                    setRowList(tempList);
                    setList(tempList); 
                    setLoading(false);   
                      
        }
      
        const setFilters = (params) =>{  
          if(!poSearchError){
            setSelected({shipmentModes: params.shipmentMode ? params.shipmentMode : '', clientIncoTerms: params.clientIncoTerm ? params.clientIncoTerm : '',
              vendorIncoTerms: params.vendorIncoTerm ? params.vendorIncoTerm: '', countries: params.countryName ? params.countryName : '', partners: '', commodityTypes: params.commodityTypeCodes[0] ? params.commodityTypeCodes[0] : ''});       
          }               
        }        
 
          const searchKey = (e) => {
            let tempList = [];
            const filterBUffer = [] ; 
            rowList.forEach((filteredList) => {        
       if(filteredList.clientIncoTerm.toLowerCase().includes(e.toLowerCase())){
         filterBUffer.push(filteredList)
        }else if(filteredList.commodityTypes.toString().toLowerCase().includes(e.toLowerCase())){
        filterBUffer.push(filteredList)
        }else if(filteredList.consignee.toLowerCase().includes(e.toLowerCase())){
         filterBUffer.push(filteredList)
        }else if(filteredList.country.toLowerCase().includes(e.toLowerCase())){
         filterBUffer.push(filteredList)
        }else if(filteredList.grantCode.toLowerCase().includes(e.toLowerCase())){
         filterBUffer.push(filteredList)
        }else if(filteredList.partner.toLowerCase().includes(e.toLowerCase())){
         filterBUffer.push(filteredList)
        }else if(filteredList.shipmentMode.toLowerCase().includes(e.toLowerCase())){
         filterBUffer.push(filteredList)
        }else if(filteredList.vendorIncoTerm.toLowerCase().includes(e.toLowerCase())){
         filterBUffer.push(filteredList)
        }
        
        tempList = filterBUffer
      })    
     
      setList(tempList)
          }

        const detectChange = (e) => {
          setSearchParam(e.target.value);
         // searchKey(e.target.value);
           }

           const handleSubmit = (event) => {
            event.preventDefault();
            filterList();
          };

          const handleSearch = (event) => {
           setSearchTerm(event.target.value)           
          }
  
          const clearSearch = () => {
            setLoading(true);
            setSearchTerm('');
            setPOSearchError(false);
            getList();           
           }

           const clearFilter = () => {
            setSelected(initialValue);
            localStorage.removeItem('Si');
           }

          const getList = () => {
            setLoading(true);
            clearFilter();
            ShippingInstructionService.search({page: page})
            .then((response) => {
                setRowCount(response.data.totalRecords);
                setList(response.data.results);
                setTempRow(response.data.results);
                setLoading(false);
            });
          }

          const poLookup = (event) => {  
            setLoading(true);     
            event.preventDefault();             
              ShippingInstructionService.searchPO(poNumber)
              .then((response) => {
                if(response.status !== 200){
                  setPOSearchError(true)
                  setLoading(false);
                  clearFilter();
                }else{
                  setFilters(response.data.filter);  
                }               
             })             
              setLoading(false);
          }

          const submitSearch = (event) => {
            setLoading(true);
            setPOSearchError(false);
            event.preventDefault();
            if(searchTerm !== ''){
                ShippingInstructionService.searchPO(searchTerm)
                .then((response) => {
                  if(response.status !== 200){
                    setPOSearchError(true)
                    setLoading(false);
                    clearFilter();                    
                  }else{
                    const filters = response.data.filter                    
                    setFilters(filters);  
                    setLoading(false);
                  }  
                })
            }else{
               getList();
            }           
          }
         
        return (
            
                <React.Fragment>
                    <Container>
                        <header>
                            <h1>Shipment Instructions</h1>
                        </header>
                                <Grid item xs={4}>
                                    <Button variant="contained" color="primary" component={RouterLink} to='/shipping-instruction/new'>Create New</Button>
                                </Grid>
                                <Grid item xs={10}>&nbsp;</Grid>                     
                                  {/* <form  onSubmit={submitSearch} >                            
                                <Grid container spacing={4}>
                                <Grid item xs={4}>
                                    <TextField
                                        name="searchTerm"
                                        fullWidth           
                                        value={searchTerm}  
                                        onChange={handleSearch}                            
                                        label="Filter shipping instruction by PO"
                                        color="primary"                                  
                                            InputProps={{
                                                endAdornment: (
                                            <IconButton
                                              sx={{ visibility: searchTerm ? "visible" : "hidden" }}
                                              onClick={() => {clearSearch()}}
                                            >
                                              <ClearIcon />
                                            </IconButton>
                                                ),
                                              }}
                                    />
                                    {poSearchError &&  <span style={{color: 'red'}}>Purchase order number not found</span>}
                                 
                                  
                                </Grid>
                                <Grid item xs={4}>
                                <Button variant="contained" color="primary" type="submit">
                                        Go
                                    </Button>
                                </Grid>
                                </Grid>
                                </form> */}
                          {/* <Grid item xs={10}>&nbsp;</Grid> */}
                            <form  onSubmit={handleSubmit}>
          
                         <Grid container spacing={4}>
                             <Grid item xs={12}>   
                      <FormControl sx={{ m: 1, minWidth: 200 }}>
                        <Autocomplete
                           value={selected.countries == null ? '' : selected.countries}
                           onChange={(event, newValue) => {
                             setSelected({ ...selected, countries: newValue == null ? "" : newValue});
                           }}  
                           options={countries.map((option) => option.name)}
                           style={{ width: 300 }}
                           renderInput={(params) => (
                             <TextField {...params} label="Country" variant="outlined" />
                           )}
                         />                      
                         </FormControl>                            
                         <FormControl sx={{ m: 1, minWidth: 150 }}>
                         <Autocomplete
                         value={selected.partners == null ? '' : selected.partners} 
                           onChange={(event, newValue) => {
                             setSelected({ ...selected, partners: newValue == null ? "" : newValue});
                           }}  
                           options={partners.map((option) => option.name)}
                           style={{ width: 200 }}
                           renderInput={(params) => (
                             <TextField {...params} label="Partner Sites (Ship-to)" variant="outlined" />
                           )}
                         />  
                        </FormControl>
                         <FormControl sx={{ m: 1, minWidth: 150 }}>
                           <InputLabel>Shipment Mode</InputLabel>
                           <Select value={selected.shipmentModes == null ? '' : selected.shipmentModes} onChange={(e) => handleChange('shipmentModes', e)}
                              endAdornment={
                                selected.shipmentModes !== '' ? (
                                    <IconButton sx={{visibility: selected.shipmentModes !== ''? "visible": "hidden"}} 
                                    onClick={() => {setSelected({
                                     ...selected, 
                                     shipmentModes: ''})}}><ClearIcon/></IconButton>
                                ) : (
                                false
                                )
                                } >
                               {shipmentModes?.map((el) => (
                      <MenuItem    value={el.name}>
                      {el.name}
                    </MenuItem>
                               ))}      
                            
                           </Select>
                         </FormControl>
                         <FormControl sx={{ m: 1, minWidth: 150 }}>
                           <InputLabel>Vendor Inco Term</InputLabel>
                           <Select value={selected.vendorIncoTerms == null ? '' : selected.vendorIncoTerms} onChange={(e) => handleChange('vendorIncoTerms', e)}
                            endAdornment={
                                selected.vendorIncoTerms !== '' ? (
                                    <IconButton sx={{visibility: selected.vendorIncoTerms !== ''? "visible": "hidden"}} 
                                    onClick={() => {setSelected({
                                     ...selected, 
                                     vendorIncoTerms: ''})}}><ClearIcon/></IconButton>
                                ) : (
                                false
                                )
                                }>
                               {vendorIncoTerms?.map((el) => (
                      <MenuItem    value={el.name}>
                      {el.name}
                    </MenuItem>
                               ))}      
                            
                           </Select>
                         </FormControl>
                         <FormControl sx={{ m: 1, minWidth: 150 }}>
                           <InputLabel>Client Inco Term</InputLabel>
                           <Select value={selected.clientIncoTerms == null ? '' : selected.clientIncoTerms} onChange={(e) => handleChange('clientIncoTerms', e)}
                              endAdornment={
                                selected.clientIncoTerms !== '' ? (
                                    <IconButton sx={{visibility: selected.clientIncoTerms !== ''? "visible": "hidden"}} 
                                    onClick={() => {setSelected({
                                     ...selected, 
                                     clientIncoTerms: ''})}}><ClearIcon/></IconButton>
                                ) : (
                                false
                                )
                                }>
                               {clientIncoTerms?.map((el) => (
                      <MenuItem    value={el.name}>
                      {el.name}
                    </MenuItem>
                               ))}      
                            
                           </Select>
                         </FormControl>
                    
                         <FormControl sx={{ m: 1, minWidth: 150 }}>
                           <InputLabel>Commodity Type</InputLabel>
                           <Select value={selected.commodityTypes == null ? '' : selected.commodityTypes} onChange={(e) => handleChange('commodityTypes', e)}
                            endAdornment={
                                selected.commodityTypes !== '' ? (
                                    <IconButton sx={{visibility: selected.commodityTypes !== ''? "visible": "hidden"}} 
                                    onClick={() => {setSelected({
                                     ...selected, 
                                     commodityTypes: ''})}}><ClearIcon/></IconButton>
                                ) : (
                                false
                                )
                                }>
                               {commodityTypes?.map((el) => (
                      <MenuItem    value={el.code}>
                      {el.code}
                    </MenuItem>
                               ))}      
                            
                           </Select>
                         </FormControl>
                                    <Button style={{marginTop: "10px"}} variant="contained" color="primary" onClick={clearFilter}>Clear Filter</Button>
                         </Grid>                            
                                </Grid>
                         </form>
                         <Box
                            component="form"
                            sx={{'& > :not(style)': { m: 1, width: '25ch' }}}
                           // style={{float: "right"}}
                            noValidate
                            autoComplete="on"
                          >   
                          <TextField type="text" defaultValue={searchParam} label="Search" variant="standard" onChange={detectChange}  />
                         </Box>
                         <Grid item xs={10}>&nbsp;</Grid>
                     
                   
                                <Grid item xs={12}>
                     
                                    <DataGrid
                                      sx={{
                                        "& .MuiDataGrid-columnHeaderTitle": {
                                          whiteSpace: "normal",
                                          lineHeight: "normal"
                                        },
                                        "& .MuiDataGrid-columnHeader": {                                          
                                          height: "unset !important"
                                        },
                                        "& .MuiDataGrid-columnHeaders": {                                        
                                          maxHeight: "168px !important"
                                        }
                                      }}
                                     
                                        rowHeight={35} autoHeight={true} rows={list}
                                        columns={columns}
                                        getRowId={(row) => row.id}
                                        pagination
                                        rowCount={rowCount}
                                        initialState={{
                                          pagination: {
                                            paginationModel: { pageSize: 50, page: 0 },
                                          },
                                        }}
                                          loading={loading}
                                          disableColumnFilter
                                          slots={{ toolbar: GridToolbar }}                                                                        
                                    />
                                </Grid>
                        
                         
                    </Container>
                </React.Fragment>
           
        );
    }
;

export default ShippingInstructions;
